export default __webpack_public_path__ + "static/media/main-logo-coal900.6209cf8f.svg";